module.exports = __webpack_public_path__ + "img/img-04.@2x.79c93e7d.png";